import { useContext } from 'react';

import { Tab, Tabs, TabsProvider } from '@cast/design-system';

import { PreparedWorkload } from 'features/workload-optimization';

import { Filters } from './_components/Filters';
import { WorkloadsTable } from './_components/WorkloadsTable';
import { useWorkloadsTableCriteria } from './_hooks/useWorkloadsTableCriteria';
import { WorkloadsTableTab } from './_types';
import { useHideHpa } from '../../_hooks/permissions/useHideHpa';
import { useShowHpaV2 } from '../../_hooks/permissions/useShowHpaV2';
import { OptimizationWorkloadsListContext } from '../context';

import { SearchProvider } from '@cast/shared-search-ui';
import { WORKLOAD_TABLE_SEARCH_URL_KEY } from 'features/cluster/workload-optimization';

export const TableSection = () => {
  const { workloads, isLoading, hasError } = useContext(
    OptimizationWorkloadsListContext
  );

  const { hideHpa } = useHideHpa();
  const { showHpaV2 } = useShowHpaV2();
  const criteria = useWorkloadsTableCriteria();

  return (
    <TabsProvider initialTab={WorkloadsTableTab.VERTICAL_OPTIMIZATION}>
      <SearchProvider<PreparedWorkload>
        criteria={criteria}
        data={workloads}
        isLoading={isLoading}
        urlKey={WORKLOAD_TABLE_SEARCH_URL_KEY}
      >
        {!hasError && (
          <>
            <Filters />
            {!hideHpa && !showHpaV2 && (
              <Tabs
                size="small"
                testId="workloads-table-tabs"
                sx={{ pb: 8 }}
                fullWidth
              >
                <Tab
                  label="Vertical optimization"
                  value={WorkloadsTableTab.VERTICAL_OPTIMIZATION}
                />
                <Tab
                  label="Horizontal optimization"
                  value={WorkloadsTableTab.HORIZONTAL_OPTIMIZATION}
                />
              </Tabs>
            )}
          </>
        )}

        <WorkloadsTable />
      </SearchProvider>
    </TabsProvider>
  );
};
